module.exports = __webpack_public_path__ + "img/manage.cfe259f.svg";